<template>
  <Card>
    <p slot="title">
      <Icon type="md-alert" />
      报表Meta管理
    </p>
    <template slot="extra">
      <router-link to="/inv/category/add" slot="extra"
        >新增Category</router-link
      >
      &nbsp; &nbsp;
      <router-link to="/inv/shortName/add" slot="extra"
        >新增ShortName</router-link
      >
      &nbsp; &nbsp;
    </template>
    <Row>
      <Col span="24">
        <Select
          v-model="query.category"
          placeholder="请选择Category"
          class="public-inp"
        >
          <Option
            v-for="item in categoryList"
            :value="item.category"
            :key="item.category"
            >{{ item.category }}
          </Option>
        </Select>
        <Select
          v-model="query.shortName"
          placeholder="请选择ShortName"
          class="public-inp"
        >
          <Option
            v-for="item in shortNameList"
            :value="item.shortName"
            :key="item.shortName"
            >{{ item.shortName }}
          </Option>
        </Select>
        <Button
          type="primary"
          icon="md-upload"
          class="public-fr"
          @click="add()"
          v-access="'inv.meta.add'"
          >配置Meta
        </Button>
        <!--      <Button type="primary" icon="md-add" class="public-fr" @click="stockImport()">初始化期初|期末库存</Button>-->
        <Button class="public-fr" @click="reset()" v-access="'inv.meta.reset'"
          >重置</Button
        >
        <Button
          class="public-fr"
          type="primary"
          icon="ios-search"
          @click="getList()"
          v-access="'inv.meta.query'"
          >查询</Button
        >
      </Col>
      <Col span="24">
        <Table
          :style="{ marginTop: '10px' }"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="tbList"
        >
          <template slot-scope="{ row, index }" slot="sort">
            <span v-show="false">{{ row.code }}</span>
            {{ index + 1 }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <!--          <a href="javascript:;" @click="editFn(row)">编辑</a> &nbsp;&nbsp;-->
            <a
              href="javascript:;"
              @click="gradeFn(row)"
              v-access="'inv.meta.edit'"
              >配置Grade列表</a
            >&nbsp;&nbsp;
            <a
              href="javascript:;"
              @click="removeFn(row)"
              v-access="'inv.meta.delete'"
              >清除配置</a
            >
          </template>
          <template slot-scope="{ row }" slot="status">
            <i-switch
              v-access="'inv.meta.status'"
              :value="row.status == 1"
              :before-change="beforeStateChange"
              @on-change="stateChange(row, $event)"
            />
          </template>
        </Table>
        <Page
          :style="{ float: 'right', marginTop: '10px' }"
          :total="total"
          show-sizer
          show-total
          prev-text="上一页"
          next-text="下一页"
          show-elevator
          @on-change="pageNumChange"
          @on-page-size-change="pageSizeChange"
        />
      </Col>
    </Row>
  </Card>
</template>
<script>
import columns from "@/views/task/columns";

export default {
  data() {
    return {
      visiable: false,
      open: false,
      query: {
        page: 1,
        rows: 10,
        category: "",
        shortName: "",
        year: "",
        month: "",
      },
      columns: [
        {
          title: "id",
          key: "id",
          width: 130,
          fixed: "left",
        },
        {
          title: "category",
          key: "category",
          width: 160,
        },
        {
          title: "shortName",
          key: "shortName",
          width: 160,
        },
        {
          title: "统计的Grade列表",
          key: "gradeMaps",
          width: 200,
        },
        {
          title: "备注",
          key: "remark",
          width: 200,
        },
        {
          title: "创建时间",
          key: "createtime",
          width: 160,
        },
        {
          title: "更新时间",
          key: "updatetime",
          width: 160,
          fixed: "right",
        },
        {
          title: "编辑",
          slot: "action",
          width: 180,
          fixed: "right",
        },
      ],
      tbList: [],
      loading: false,
      total: 0,
      isDisabled: false,
      categoryList: [],
      shortNameList: [],
    };
  },
  created() {
    this.getList();
    this.getCategoryList();
    this.getShortNameList();
  },
  methods: {
    getCategoryList() {
      this.$api.getInvReportCategoryList({}).then((res) => {
        if (res.code == "200") {
          //this.categoryList = res.data;
          res.data.forEach((item) => {
            if (item.category != "All") {
              this.categoryList.push({
                category: item.category,
              });
            }
          });
        }
      });
    },
    getShortNameList() {
      this.$api.getInvReportShortNameList({}).then((res) => {
        if (res.code == "200") {
          this.shortNameList = res.data;
        }
      });
    },
    getList() {
      let data = this.query;
      this.loading = true;
      this.$api.getInvReportMetaList(data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          this.tbList = res.data;
          this.total = res.total;
        }
      });
    },
    reset() {
      this.query.category = "";
      this.query.shortName = "";
      this.query.year = "";
      this.query.month = "";
      this.$nextTick(() => {
        this.getList();
      });
    },
    uploadToggle() {
      this.visiable = !this.visiable;
    },
    // 页码
    pageNumChange(pageNum) {
      this.query.page = pageNum;
      this.getList();
    },
    // 页数
    pageSizeChange(pageSize) {
      this.query.rows = pageSize;
      // 页码变动触发pageNumChange
      if (this.query.page == 1) {
        this.getList();
      } else {
        this.query.page = 1;
      }
    },
    add() {
      this.$router.push({
        name: "invMetaAdd",
      });
    },
    editFn(row) {
      this.$router.push({
        name: "invMetaAdd",
        query: {
          id: row.id,
        },
      });
    },
    gradeFn(row) {
      this.$router.push({
        name: "gradeMap",
        query: {
          id: row.id,
          sn: row.shortName,
        },
      });
    },
    removeFn(row) {
      this.$Modal.confirm({
        title: "提示[清除后统计默认读取全部的Grade列表]",
        content: `确认删除[${row.shortName}]对应自定义配置的Grade列表[${row.gradeMaps}]`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          this.$api
            .removeInvMetaGradeMap({ shortName: row.shortName })
            .then((res) => {
              if (res.code == "200") {
                this.getList();
              } else {
                this.$Message.error(res.Message);
              }
            });
        },
      });
    },
  },
};
</script>
<style scoped>
.md5 {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/invreport/meta.vue